



















import { Component, Vue, Prop } from 'vue-property-decorator';
import { ArrowRightSmallIcon } from '@nimiq/vue-components';

@Component({ components: { ArrowRightSmallIcon } })
export default class NimiqButton extends Vue {
    @Prop(String) private text?: string;
    @Prop(String) private link?: string;
    @Prop({ type: String, default: 'light-blue' }) private color!: string;
    @Prop(Boolean) private arrow?: boolean;
    @Prop(Boolean) private small?: boolean; // "big" is default
    @Prop(Boolean) private medium?: boolean;
    @Prop(Boolean) private inverse?: boolean;
    @Prop(Boolean) private back?: boolean;
}
